import { TextField } from '@mui/material'
import { formatOrgAndUsername } from '../utils/format'

/**
 *
 * @param {setOrgName} function - required function used to push the valid entered org name to parent component to create org.
 * @param {createOrg} function - optional function used to create org when pressing 'enter' key
 * @returns
 */
export const CreateOrgInput = ({ orgName, setOrgName, createOrg, errorMsg, ...rest }) => {
  return (
    <TextField
      autoFocus
      variant="outlined"
      placeholder="Org Name"
      label="Org Name"
      helperText={errorMsg}
      error={Boolean(errorMsg)}
      fullWidth
      value={orgName}
      onChange={async (event) => {
        const value = formatOrgAndUsername(event.currentTarget.value)

        setOrgName(value)
      }}
      onKeyUp={(event) => {
        if (event.key === 'Enter' && createOrg) {
          createOrg()
        }
      }}
      {...rest}
    />
  )
}
